import hello from "hellojs"

type Provider = "b2c"

/** Configures all the idp and scopes available to Authentication components */
export function configureAccessManagement(tenant: string, policyId: string, clientId: string, redirectUri: string) {

  const b2c = initAzureADB2C("Imagined.Cloud B2C", tenant, policyId, {
    "graph": "https://graph.windows.net/.default",
    "portal": clientId
  })

  const providers = { b2c }

  const providerScopeMap: [Provider, string][] = [
    ["b2c", "graph"],
    ["b2c", "portal"],
  ]

  hello.init(providers)

  //https://github.com/MrSwitch/hello.js/issues/348#issuecomment-154735343
  applyMultiscopeWorkaround(providerScopeMap)
  const helloJsInit = mapMultiscopeWorkaroundInit(providerScopeMap, {
    "b2c": clientId
  })

  hello.init(helloJsInit, { redirect_uri: redirectUri, scope: "openid" })

  return () => Object.entries(helloJsInit).reduce((acc, [name, _]) => ({ ...acc, [name]: hello.getAuthResponse(name) }), {})
}

function initAzureADB2C(name: string, tenant: string, policy: string, scope?: { [scope: string]: string }): hello.HelloJSServiceDef {
  return {
    name,
    oauth: {
      version: 2,
      auth: `https://login.microsoftonline.com/tfp/${tenant}/${policy}/oauth2/v2.0/authorize`,
      grant: `https://login.microsoftonline.com/tfp/${tenant}/${policy}/oauth2/v2.0/token`,
      response_type: "id_token token"
    },
    scope_delim: ' ',
    scope,
    form: false,
    login: req => {
      req.qs.nonce = req.qs.nonce || String(Date.now())
    },
    logout: function () {
      window.location.href = `https://login.microsoftonline.com/tfp/${tenant}/${policy}/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin + window.location.pathname}`
      return true
    }
  }
}

function applyMultiscopeWorkaround(config: [Provider, string][]) {
  for (const [provider, scope] of config) {
    let workaround = hello as any
    workaround.services[`${provider}_${scope}`] = workaround.services[provider]
  }
}

function mapMultiscopeWorkaroundInit(scopeMap: [Provider, string][], providerConfig: { [provider in Provider]: string }) {
  let toReturn: { [k: string]: string } = { ...providerConfig }

  for (const [provider, scope] of scopeMap) {
    toReturn[`${provider}_${scope}`] = providerConfig[provider]
  }

  return toReturn
}
